import React from "react";

const ACCENT = {
  light: "#3b82f6",
  dark: "#60a5fa"
};
const BG = {
  light: "rgba(59,130,246,0.10)",
  dark: "rgba(59,130,246,0.15)"
};

function GitRollCard({ username = "Meetjain1", currentTheme = "light" }) {
  const profileUrl = "https://gitroll.io/profile/uMZcGY1XUZ7YaGdlFg8Twr8a01lz2";

  return (
    <div
      className="stat-card"
      style={{
        background: BG[currentTheme],
        color: currentTheme === "dark" ? "#fff" : "#222"
      }}
    >
      <div style={{ width: "100%" }}>
        {/* Header */}
        <div
          style={{
            fontWeight: 700,
            fontSize: 20,
            marginBottom: 8,
            color: ACCENT[currentTheme]
          }}
        >
          <span style={{ marginRight: 8 }}>GitRoll</span>
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: ACCENT[currentTheme],
              textDecoration: "none",
              fontSize: 16
            }}
          >
            @{username}
          </a>
        </div>

        {/* Title */}
        <div
          style={{
            fontWeight: 600,
            fontSize: 17,
            marginBottom: 8,
            opacity: 0.95
          }}
        >
          Exemplary Full-Stack Developer
        </div>

        {/* Overall Rating */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
            marginBottom: 8
          }}
        >
          <span
            style={{
              fontWeight: 700,
              fontSize: 15,
              color: ACCENT[currentTheme]
            }}
          >
            Overall Rating
          </span>
          <span
            style={{
              fontWeight: 700,
              fontSize: 18,
              color: "#fbbf24",
              background: "#fff3",
              borderRadius: 8,
              padding: "2px 10px",
              marginLeft: 4
            }}
          >
            S
          </span>
          <span
            style={{
              fontWeight: 700,
              fontSize: 18,
              color: ACCENT[currentTheme]
            }}
          >
            9.05
          </span>
        </div>

        {/* Percentile */}
        <div
          style={{
            fontSize: 15,
            marginBottom: 6,
            opacity: 0.85
          }}
        >
          <span style={{ fontWeight: 600 }}>Above</span>{" "}
          <span style={{ fontWeight: 700 }}>98%</span> of people
        </div>

        {/* Top 1% */}
        <div
          style={{
            fontSize: 15,
            marginBottom: 16,
            opacity: 0.85
          }}
        >
          <span style={{ fontWeight: 600 }}>Top 1% in IN</span>
        </div>

        {/* Note */}
        <div
          style={{
            marginTop: 16,
            fontSize: 13,
            opacity: 0.7
          }}
        >
          <span style={{ fontWeight: 600 }}>Note:</span> For more details, see your {" "}
          <a
            href={profileUrl}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: ACCENT[currentTheme] }}
          >
            GitRoll profile
          </a>.
        </div>
      </div>
    </div>
  );
}

export default GitRollCard; 